module.exports = __webpack_public_path__ + "static/media/ceo_banner_english.dc57cc5e.png";